import React from 'react';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import Text from '../../../../Components/Base/Text/Text';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import { Size } from '../../../../Enums/Size.enum';
import PatientProfileDataCompareTable from '../../../../Components/PatientProfile/PatientProfileDataCompare/PatientProfileDataCompareTable';
import { PatientDataCompareKey } from '../../../../Helpers/Patient/mapPatientDataToCompareTable.helper';
import { PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS } from '../../../../Helpers/Patient/compareTableTranslations.helper';
import useTranslation from '../../../../Hooks/useTranslation';

import styles from './PatientAutoVerify.module.scss';

interface Props {
	isOpen: boolean;
	patientId: string;
	mismatchKeys: PatientDataCompareKey[];
	onClose: () => void;
}

const PatientAutoVerifyMismatchModal: React.FC<Props> = ({
	isOpen,
	patientId,
	mismatchKeys,
	onClose,
}) => {
	const { t } = useTranslation();

	const mismatchList = mismatchKeys
		.map(key => t(PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS[key] || key))
		.join(', ');

	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			size={Size.LG}
			title='nczi.patientAutoVerify.mismatchTitle'>
			<>
				<Text tx='nczi.patientAutoVerify.mismatchText' firstUpper />
				{!!mismatchList.length && (
					<Text
						tx='nczi.patientAutoVerify.mismatchFields'
						txParams={{ fields: mismatchList }}
						firstUpper
					/>
				)}
				<PatientProfileDataCompareTable patientId={patientId} />
				<div className={styles.controls}>
					<Button
						theme={Theme.GREEN}
						title='base.shared.ok'
						onClick={onClose}
						fitContent
					/>
				</div>
			</>
		</BaseModal>
	);
};

export default PatientAutoVerifyMismatchModal;
